import { gql } from "@apollo/client";
import { DEPOSIT_INFO } from "../fragments";

export const GET_DEPOSITS = gql`
  query deposits {
    deposits {
      ...depositInfo
    }
  }
  ${DEPOSIT_INFO}
`;
